<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog"  width="550px" :destroy-on-close="true"  :before-close="cancel">
    <el-form label-width="120px" ref="form" :model="form">
      <div v-for="(item,index) in form.userInfo" :key="index">
        <el-form-item :label="'客户'+(form.userInfo.length>1?(index+1):'')+'姓名'" prop="contactName">
          <el-input readonly v-model="item.contactName" clearable></el-input>
        </el-form-item>
        <el-form-item :label="'客户'+(form.userInfo.length>1?(index+1):'')+'邮箱'" prop="email">
          <el-input readonly v-model="item.email" clearable></el-input>
        </el-form-item>
        <el-form-item :label="'客户'+(form.userInfo.length>1?(index+1):'')+'电话号码'" prop="phone">
          <el-input readonly v-model="item.phone" clearable></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancel">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "CustomerUserInfo",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'客户信息',
      form:{
        userInfo:[
          {
            contactName:'',
            email:'',
            phone:''
          }
        ]
      },
    }
  },
  mounted() {
  },
  watch: {
    selectDetail:{
      handler(newVal){
        if(newVal&&newVal.length > 0){
          this.form.userInfo = JSON.parse(JSON.stringify(newVal))
        }
      },
      immediate:true
    },
  },
  methods: {
    cancel(){
      this.$emit('submit','cancel')
    },
  }
}
</script>

<style scoped>

</style>
